var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0634 22C7.1064 22 0.284256 13.7411 0 0H5.99024C6.18583 10.0845 10.6035 14.3584 14.1007 15.2384V0H19.7414V8.69755C23.1969 8.32191 26.8244 4.3606 28.0475 0H33.6882C32.7494 5.37194 28.8142 9.33588 26.0159 10.9672C28.8142 12.2885 33.2971 15.7454 35 22H28.7907C27.4581 17.8154 24.1357 14.5791 19.7414 14.1378V22H19.0634Z",
    fill: "#073AE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVk);
export default __webpack_public_path__ + "static/media/social-vk.6049483c2bb1359c013a5f8273340652.svg";
export { ForwardRef as ReactComponent };